import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-layout-reports',
  templateUrl: './app.layout-reports.component.html'
})
export class AppLayoutReportsComponent {
  displaySidebar = false;

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = 'krediya.v2-theme.css';
    }
  }

  toggleSidebar(): void {
    this.displaySidebar = !this.displaySidebar;
  }
}
